import { render, staticRenderFns } from "./contactUsIntroduction.vue?vue&type=template&id=2dd09222&"
import script from "./contactUsIntroduction.vue?vue&type=script&lang=js&"
export * from "./contactUsIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./contactUsIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports